import { useEffect, useState } from "react";

import { AccordionBody } from "./AccordionBody";
import { AccordionLayout } from "./AccordionLayout";

import { useLanguage } from "@hooks/useLanguage";
import { PromotionDataType, PromotionDetailsType } from "@type/HRM/promotions";

export const InitiatePromotionAccordion = ({
  promotionData,
  isDisabled,
  showActionButton,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
  handlePromotionDelete,
  handlePromotionUpdate,
  recommendationAction,
}: {
  promotionData: PromotionDataType;
  isDisabled: boolean;
  showActionButton: boolean;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
  handlePromotionDelete: (arg: number) => void;
  handlePromotionUpdate: (promotionDetailsData: PromotionDetailsType) => void;
  recommendationAction: (
    promotionDetailsId: number,
    actionType: string,
  ) => void;
}) => {
  const [accordionData, setAccordionData] = useState([]);

  const { language } = useLanguage();

  useEffect(() => {
    setAccordionData(promotionData?.promotionDetails as any);
  }, [promotionData]);

  return (
    <div className="d-flex flex-column gap-8 mt-8">
      {accordionData?.map((promotionDetails: PromotionDetailsType) => {
        const { nameEn, nameBn, unitBn, unitEn, positionName, positionNameBn } =
          promotionDetails.employee || {};

        const employeeName = language === "bn" ? nameBn : nameEn;
        const employeeUnit = language === "bn" ? unitBn : unitEn;
        const employeePosition =
          language === "bn" ? positionNameBn : positionName;

        return (
          <AccordionLayout
            key={promotionDetails.promotionDetailsId}
            accordionHeader={{
              title: employeeName,
              subtitle: `${employeePosition} (${employeeUnit})`,
            }}
            promotionDetailsData={promotionDetails}
            action={recommendationAction}
            showActionBtn={showActionButton}
            accordionBody={
              <AccordionBody
                promotionData={promotionData}
                promotionDetailsData={promotionDetails}
                isDisabled={isDisabled}
                handleDelete={handlePromotionDelete}
                handleUpdate={handlePromotionUpdate}
                setIsSuccessModalOpen={setIsSuccessModalOpen}
                setIsErrorModalOpen={setIsErrorModalOpen}
              />
            }
            className="p-8 bg-primary-25 rounded-4 border border-primary"
          />
        );
      })}
    </div>
  );
};
